function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.454 3.99L19.694 12h-1.67l3.478-9.242h1.067l-.115 1.231zm2.31 8.01l-2.767-8.01-.12-1.232h1.072L26.441 12h-1.676zm-.133-3.428v1.263h-5.027V8.572h5.027zm6.354-.019H28.58V7.29h2.405c.42 0 .758-.068 1.016-.203s.447-.322.565-.559c.123-.24.184-.516.184-.825 0-.292-.061-.565-.184-.819a1.403 1.403 0 0 0-.565-.622c-.258-.156-.596-.235-1.015-.235h-1.917V12h-1.594V2.758h3.51c.716 0 1.323.127 1.822.38.504.25.887.597 1.15 1.042.262.44.393.943.393 1.51 0 .597-.131 1.11-.394 1.537-.262.427-.645.755-1.149.983-.499.229-1.106.343-1.822.343zm8.303 0h-2.405V7.29h2.405c.42 0 .758-.068 1.016-.203s.446-.322.565-.559c.123-.24.184-.516.184-.825 0-.292-.061-.565-.184-.819a1.403 1.403 0 0 0-.565-.622c-.258-.156-.597-.235-1.016-.235h-1.917V12h-1.593V2.758h3.51c.716 0 1.323.127 1.822.38.504.25.887.597 1.149 1.042.262.44.394.943.394 1.51 0 .597-.132 1.11-.394 1.537-.262.427-.645.755-1.149.983-.5.229-1.106.343-1.822.343z",
  fill: "#1063CD"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#app-login_svg__clip0_19861_936)",
  stroke: "#1063CD",
  strokeLinecap: "round"
}, React.createElement("path", {
  d: "M.583 12.567v-.583a4.083 4.083 0 0 1 8.167 0v.583"
}), React.createElement("path", {
  d: "M7.583 9.067a2.917 2.917 0 0 1 5.834 0v.292"
}), React.createElement("path", {
  d: "M4.667 7.9a2.333 2.333 0 1 0 0-4.666 2.333 2.333 0 0 0 0 4.666zM10.5 6.15a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5z",
  strokeLinejoin: "round"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "app-login_svg__clip0_19861_936"
}, React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .9)",
  d: "M0 0h14v14H0z"
})));

const SvgAppLogin = props => React.createElement("svg", _extends({
  width: 44,
  height: 16,
  fill: "none"
}, props), _ref, _ref2, _ref3);

export default SvgAppLogin;